<template>
  <div id="app"
       class="wrapper animate-in">

    <Header v-show="!isHiddenTop"></Header>
    <Sidebar v-show="!isHiddenMenu"></Sidebar>
    <div :class="['content-wrapper', isHiddenTop? 'hide-top':'', 'fz-bg-white', isHiddenMenu?'fz-bg-content':'', 
        isStatisticsPage?'fz-bg-black':'']">

      <router-view v-if="isRouterAlive"></router-view>
      <loading :active.sync="isLoading"
               :can-cancel="false"
               :is-full-page="fullPage"></loading>
    </div>
    <Footer></Footer>

  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";
import Footer from "@/components/Footer/Footer.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import Loading from 'vue-loading-overlay';

import { mapState } from 'vuex';

export default {
  name: "home",
  components: {
    Header,
    Footer,
    Sidebar,
    Loading
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true,
      collapsed: true,
      isLoading: false,
      messages: 3,
      fullPage: true
    }
  },
  computed: {
    ...mapState(['isHiddenMenu', 'isStatisticsPage', 'isHiddenTop'])
  },
  destroyed () {
    if (localStorage.getItem('navIndex')) {
      localStorage.removeItem('navIndex');
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
};
</script>
<style lang="scss">
* {
  scroll-behavior: smooth;
}
body {
  min-width: 1280px;
  overflow-x: auto !important;
}
.loadding {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 99999;
}
.content-wrapper {
  position: relative;
}
.vld-overlay {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  align-items: center;
  display: none;
  justify-content: center;
  overflow: hidden;
  z-index: 9999;
}

.vld-overlay.is-active {
  display: flex;
}

.vld-overlay.is-full-page {
  z-index: 9999;
  position: absolute;
}

.vld-overlay .vld-background {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  background: #fff;
  opacity: 0.5;
}

.vld-overlay .vld-icon,
.vld-parent {
  position: relative;
}
.modal-backdrop {
  z-index: 100 !important;
}

.hide-top {
  margin-top: 0;
}
// // 页面进入动画样式
// .animate-in {
//     animation: animate-in .5s forwards;
// }

// // 页面进入动画效果
// @keyframes animate-in {
//     from {
//         transform: scale(1.1);
//     }

//     to {
//         transform: scale(1);
//     }
// }
.fz-swiper-con {
  padding: 10px;

  border-radius: 4px;
  border: 1px solid #bebebe;
  // min-height: 275px;
  .fz-swiper-top-con {
    height: 75px;
    display: flex;
    flex-direction: row;
    .fz-swiper-top-left {
      padding-left: 10px;

      display: flex;
      flex-direction: column;
      width: 60px;
    }
    .fz-swiper-line {
      font-size: 0px;
      height: 2px;
      background-color: #6d779c;
    }
    .fz-swiper-top-right {
      flex: 1;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding-left: 10px;
      padding-top: 15px;

      .fz-status-txt {
        .red {
          display: block;
          font-size: 14px;
        }
        .green {
          display: block;
          font-size: 16px;
        }
      }
      .fz-swiper-btn {
        text-align: center;
        .icon {
          font-size: 48px;
        }
        font-size: 12px;
      }
    }
    .fz-swiper-txt {
      text-align: center;
      font-size: 28px;
      line-height: 34px;
      flex: 1;
      span {
        font-size: 12px;
        display: inline;
      }
    }
  }
  .fz-swiper-btm {
    border-top: 1px solid #afafaf;
    padding-top: 10px;
    // min-height: 110px;
    .fz-status-txt {
      font-size: 22px;
      text-align: right;
      padding-right: 15px;
      margin-bottom: 5px;
    }
    .status-p {
      line-height: 22px;
    }
  }
}
.fz-swiper-top-tbn {
  border: 1px solid #ddd;
  padding: 5px 10px;
  display: flex;
  flex-direction: row;
  border-radius: 40px;
  // background: #ff9800;
  background: #e3e8ed;
  background-image: linear-gradient(0deg, #e3e8ed, #fff);

  cursor: pointer;
  &:hover {
    background: #f1f1f1;
  }
  .fz-swiper-btn {
    background: #fff;
    color: #ff9800;
    border-radius: 40px;
    width: 48px;
    height: 48px;
    text-align: center;
    line-height: 30px;
    img {
      width: 48px;
    }
  }
  p {
    line-height: 30px;
    margin: 0;
    // color: #fff;
    margin-top: 5px;
    line-height: 22px;
    text-align: center;
    margin-left: 15px;
    font-size: 14px;
  }
}

.fz-swiper-top-tbn {
  border: 1px solid #ddd;
  padding: 5px 10px;
  display: flex;
  flex-direction: row;
  border-radius: 40px;
  // background: #ff9800;
  background: #e3e8ed;
  background-image: linear-gradient(0deg, #e3e8ed, #fff);

  cursor: pointer;
  &:hover {
    background: #f1f1f1;
  }
  .fz-swiper-btn {
    background: #fff;
    color: #ff9800;
    border-radius: 40px;
    width: 48px;
    height: 48px;
    text-align: center;
    line-height: 30px;
    img {
      width: 48px;
    }
  }
  p {
    line-height: 30px;
    margin: 0;
    // color: #fff;
    margin-top: 5px;
    line-height: 22px;
    text-align: center;
    margin-left: 15px;
    font-size: 14px;
  }
}
.mini-fz-swiper-top-tbn {
  border: 1px solid #ddd;
  padding: 3px 5px;
  display: flex;
  flex-direction: row;
  border-radius: 40px;
  // background: #ff9800;
  background: #e3e8ed;
  background-image: linear-gradient(0deg, #e3e8ed, #fff);
  max-width: 120px;
  margin: 0 auto;
  cursor: pointer;
  &:hover {
    background: #f1f1f1;
  }
  .fz-swiper-btn {
    background: #fff;
    color: #ff9800;
    border-radius: 40px;
    width: 28px;
    height: 32px;
    text-align: center;
    line-height: 30px;
    img {
      width: 32px;
    }
  }
  p {
    line-height: 20px;
    margin: 0;
    // color: #fff;
    margin-top: 5px;
    line-height: 22px;
    text-align: center;
    margin-left: 10px;
    font-size: 14px;
  }
}

.fz-swiper-top-tbn {
  border: 1px solid #ddd;
  padding: 5px 10px;
  display: flex;
  flex-direction: row;
  border-radius: 40px;
  // background: #ff9800;
  background: #e3e8ed;
  background-image: linear-gradient(0deg, #e3e8ed, #fff);

  cursor: pointer;
  &:hover {
    background: #f1f1f1;
  }
  .fz-swiper-btn {
    background: #fff;
    color: #ff9800;
    border-radius: 40px;
    width: 48px;
    height: 48px;
    text-align: center;
    line-height: 30px;
    img {
      width: 48px;
    }
  }
  p {
    line-height: 30px;
    margin: 0;
    // color: #fff;
    margin-top: 5px;
    line-height: 22px;
    text-align: center;
    margin-left: 15px;
    font-size: 14px;
  }
}

.app-box {
  background-color: #eee;
  border-radius: 4px;
  position: relative;
  padding: 6px;
  padding-bottom: 14px;
  margin-top: 10px;
  .app-icon {
    position: absolute;
  }
  .app-con {
    font-size: 22px;
    margin-left: 30px;
    margin-top: -6px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 34px;
    span {
      font-size: 12px;
    }
  }
  .app-label {
    font-size: 12px;
    color: #999;
    position: absolute;
    left: 10px;
    bottom: 0px;
  }
}
.box-msg {
  background: #f4f4f4;
  border-radius: 8px;
  padding: 8px;
  .msg-title {
    color: #999;
  }
}
.msg-con {
  padding: 5px 0;
  height: 65px;
  color: #666;
}
.app-item-box {
  width: calc(20% - 20px);
  @media (min-width: 1200px) {
    width: calc(20% - 20px);
  }

  @media (min-width: 1200px) and (max-width: 1600px) {
    width: calc(20% - 20px);
  }

  @media (min-width: 1600px) and (max-width: 2560px) {
    width: calc(14% - 20px);
  }
  @media (min-width: 2560px) {
    width: calc(10% - 20px);
  }
  margin: 0 10px 20px 10px;
  background: #f8f8f8;
  border-radius: 4px;
  border: 1px solid #00000000;
  float: left;
  &.active {
    border: 1px solid #038afc;
  }
  .app-itm-title {
    background: #7387ac;
    line-height: 24px;
    padding: 5px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    color: #fff;
    .span {
      font-size: 20px;
      padding-left: 10px;
    }
    border-start-start-radius: 4px;
    border-start-end-radius: 4px;
    .dian {
      display: inline-block;
      background: #00f940;
      border-radius: 10px;
      font-size: 0;
      width: 10px;
      height: 10px;
    }
    .gray {
      color: #e0e2e1;
      .dian {
        background: #e0e2e1;
      }
    }
    .green {
      color: #00f940;
    }
  }

  .app-itm-con {
    height: 68px;
    padding: 5px;
    .ctls {
      padding: 0;
      margin: 0;
      z-index: 999999;
      position: relative;
      height: 18px;
      line-height: 18px;
      display: flex;
      justify-content: space-between;
      .iconfont {
        cursor: pointer;
        color: #b3b3b3;
        &:hover {
          color: #a5a5a5;
        }
      }
      .label {
        color: #999;
      }
    }

    .itm-con-con {
      display: flex;
      padding-left: 10px;
      position: relative;
      padding-top: 20px;

      height: 60px;
      .co-label {
        position: absolute;
        top: 4px;
        right: 36px;
        color: #999;
      }
      .con-icon {
        width: 38px !important;
        height: 38px !important;
        padding-left: 20px;
        margin-top: 0px;
      }
      .con-icon-txt {
        flex: 1;
        font-size: 12px;
        padding: 0 10px;
        position: relative;
        text-align: right;
        span {
          font-size: 26px;
        }
      }
    }
  }
}
.app-checkbox-item {
  background: #f0f0f0;
  border-radius: 5px;
  padding: 3px 5px;
  display: inline-block;
  width: 22%;
  margin-bottom: 10px;
  margin-right: 3%;
  line-height: 20px;
  padding-top: 8px;
  flex-direction: row;
  position: relative;
  &.disabled {
    .check-icon {
      -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
      -ms-filter: grayscale(100%);
      -o-filter: grayscale(100%);
      filter: grayscale(100%);
      filter: gray;
    }
    label {
      -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
      -ms-filter: grayscale(100%);
      -o-filter: grayscale(100%);
      filter: grayscale(100%);
      filter: gray;
    }
  }
  .check-icon {
    width: 16px !important;
    height: 16px !important;
    display: inline-block;
    position: absolute;
    left: 10px;
    top: 5px;
  }
  label {
    margin-top: -3px;
    display: block;
    margin-left: 20px;
    text-align: center;
  }
}
.app-pro {
  display: flex;
  background: #f4f4f4;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  .app-pro-item {
    width: 50%;
    padding: 5px 6px;
    border-bottom: 2px solid #fff;
    border-right: 2px solid #fff;
    &:nth-child(even) {
      border-right: 0;
    }
    .pro-label {
      font-size: 12px;
      text-align: right;
      margin-top: 0px;
      color: #999;
    }
    .pro-txt {
      font-size: 24px;
      margin-top: -5px;
      padding-left: 15px;
      text-align: left;
      span {
        font-size: 12px;
      }
    }
  }
}
.app-light-box {
  .app-pro-item {
    width: 33.33%;
    &:nth-child(even) {
      border-right: 2px solid #fff;
    }
    &:nth-child(3n + 2) {
      border-right: 0;
    }
    .pro-txt {
      font-size: 22px;
      margin-top: -5px;
      padding-left: 15px;
      text-align: left;
      span {
        font-size: 12px;
      }
    }
  }
}
.app-pro-con {
  margin-top: -10px;

  .app-con {
    font-size: 18px !important;
    padding-top: 10px;
    height: 35px;
  }
}
.icon-wea {
  width: 24px !important;
  height: 24px !important;
  display: inline-block;
  animation: turn 3s linear infinite;
}

@keyframes turn {
  0% {
    -webkit-transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(90deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(270deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

.btn-bar {
  background: #ededed;
  color: #555555;
  display: inline-block;
  line-height: 18px;
  font-size: 13px;
  padding-left: 10px;
  border-radius: 18px;
  .status {
    display: block;
    float: left;
    padding-top: 2px;
    padding-right: 10px;
    line-height: 18px;
  }

  .btns {
    display: inline-block;

    a {
      width: 32px;
      line-height: 20px;
      display: inline-block;
      border-left: 3px solid #fff;
      height: 22px;
      text-align: center;
      color: #666;
      &.red {
        &.active {
          background: #ff0000;
          // border-left: 1px solid #ff0000;
          color: #fff;
        }
      }
      &.yellow {
        &.active {
          background: #ffba00;
          // border-left: 1px solid #ffba00;
          color: #fff;
        }
      }
      &.green {
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        width: 42px;
        padding-right: 10px;
        &.active {
          background: #00c412;
          //border-left: 1px solid #00c412;
          color: #fff;
        }
      }
    }
  }
}

.base-pro {
  background: #f8f8f8;
  border-radius: 6px;
  padding: 10px 5px;
  margin-left: -5px;
  margin-right: -5px;
  .table {
    margin-bottom: 0;
  }
  .base-list {
    line-height: 24px;
    span {
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 50%;
    }
  }
}
.pro-ctrls {
  display: flex;
  justify-content: space-evenly;
  .ctls-icons {
    text-align: center;
    display: flex;
    flex: 1;
    line-height: 20px;
    color: #038afc;
    font-size: 14px;
    &.active {
      -webkit-filter: none;
      -moz-filter: none;
      -ms-filter: none;
      -o-filter: none;
      filter: none;

      .icon_n {
        -webkit-filter: none;
        -moz-filter: none;
        -ms-filter: none;
        -o-filter: none;
        filter: none;
      }
    }
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
    .icon_n {
      width: 28px;
      height: 28px;
      margin-top: -4px;
      -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
      -ms-filter: grayscale(100%);
      -o-filter: grayscale(100%);
      filter: grayscale(100%);
      filter: gray;
    }
  }
}
.icon-status {
  font-size: 11px;
  .iconfont {
    font-size: 12px;
  }
}
</style>
